export const Loading = () => {
  return <div>Loading...</div>;
};
